import React from 'react';
import { Box, Button, Flex, Heading, Stack, Spacer } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { eeSchool } from '../data';
import { makeFields } from './utils';

export const EESchool = ({ state, setter, remove, id, onBlur }) => {
	const {
		name,
		city,
		country,
		startDate,
		endDate,
		degree,
		specialization,
		tuitionForm,
	} = makeFields(state, setter, eeSchool, onBlur);
	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{state.name || 'Место учёбы'}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...name} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...city} />
				<ProfileSelect pb={6} {...country} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...startDate} />
				<ProfileField pb={6} {...endDate} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...degree} />
				<ProfileSelect pb={6} {...tuitionForm} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...specialization} />
			</Stack>
		</Box>
	);
};
